"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETypePersonneJuridiqueTrads = void 0;
exports.ETypePersonneJuridiqueTrads = {
    personne_physique: "Personne physique",
    personne_morale: "Personne morale",
};
